export type SalesErrorNotification = {
  message: string;
  args: Record<string, string>;
};

const MESSAGE_BY_CODE: Record<string, string> = {
  email_taken: "crm.profile.email_taken",
  secondary_email_taken: "crm.profile.secondary_email_taken",
  secondary_email_is_primary: "crm.profile.secondary_email_is_primary",
  invalid_secondary_email: "crm.profile.secondary_email_invalid",
  too_many_secondary_emails: "crm.profile.too_many_secondary_emails",
  // Almikia Epic E3b (TASK-060/061): a clave de asesora is unique; never
  // surface the raw HTTP error, always this mapped Spanish message.
  advisor_code_taken: "crm.profile.advisor_code_taken",
  // Almikia Epic E3b-2 (TASK-080, database guard TASK-077): a retired clave
  // is never reassigned; never surface the raw HTTP error, always this
  // mapped Spanish message.
  advisor_code_reserved: "crm.profile.advisor_code_reserved",
};

export const getSalesErrorNotification = (
  error: unknown,
  fallbackMessage = "crm.profile.update_error",
): SalesErrorNotification => {
  const { code, email, advisor_code } = (error ?? {}) as {
    code?: string;
    email?: string;
    advisor_code?: string;
  };
  const message = code ? MESSAGE_BY_CODE[code] : undefined;

  return {
    message: message ?? fallbackMessage,
    args: {
      email: email ?? "",
      ...(advisor_code !== undefined ? { advisor_code } : {}),
    },
  };
};
